import { getTimeDifference } from 'containers/AppContainer/utils';
import { isEmpty, get, groupBy, sumBy } from 'lodash';
export const extractUser = (
  userInboxes: any,
  inboxe: any,
  selectedArea?: any,
  listings?: any,
) => {
  let filtredInboxes;
  if (selectedArea) {
    const transactionInboxeAreaId = get(
      get(listings, 'transactionInboxeArea', []).find(
        (el: any) =>
          el.managerInboxesId === inboxe &&
          el.transactionAreaId === selectedArea,
      ),
      'id',
    );
    filtredInboxes = userInboxes.filter(
      (el: any) =>
        el?.managerInboxesId === inboxe &&
        el?.transactionInboxeAreaId === transactionInboxeAreaId,
    );
  } else {
    filtredInboxes = userInboxes.filter(
      (el: any) => el?.managerInboxesId === inboxe,
    );
  }

  if (isEmpty(filtredInboxes)) {
    return [];
  } else {
    return filtredInboxes.map((el: any) => ({
      managerInboxesId: el?.managerInboxesId,
      userPrivilegesId: el?.userPrivilegesId,
      transactionInboxeAreaId: el?.transactionInboxeAreaId,
      name: el?.userPrivilege?.name,
      sagisName: el?.userPrivilege?.sagisName,
      inboxeId: el?.id,
      userPrivilege: {
        ...el?.userPrivilege,
      },
    }));
  }
};
export const extractInboxesByUserId = (userInboxes: any, userId: any) => {
  const filtredInboxes = userInboxes.filter(
    (el: any) => el?.userPrivilegesId === userId,
  );

  if (isEmpty(filtredInboxes)) {
    return [];
  } else {
    return filtredInboxes.map((el: any) => ({
      managerInboxe: el?.managerInboxe?.title,
      userPrivilegesId: el?.userPrivilegesId,
      name: el?.userPrivilege?.name,
      managerInboxesId: el?.managerInboxesId,
      inboxeId: el?.id,
      userPrivilege: {
        ...el?.userPrivilege,
      },
    }));
  }
};

export const constructTitleOfInboxes = (listOfInboxes: any) => {
  let sentence = '';
  listOfInboxes.map((el: any) => {
    return (sentence += ' ' + el?.managerInboxe + ',');
  });
  return sentence;
};

export const constructUnassignedManagersInboxes = (
  managers: any,
  usersInboxes: any,
) => {
  return managers.map((el: any) => ({
    ...el,
    inboxes: [
      ...usersInboxes.filter((item: any) => item.userPrivilegesId === el.id),
    ],
  }));
};

export const constructAssignedManagerIds = (userInboxes: any) => {
  return userInboxes.map((el: any) => el.userPrivilegesId);
};

export const countClaimsInboxes = (managerNotifications: any, id: any) => {
  return managerNotifications.filter(
    (item: any) =>
      Number(item?.managerNotificationType?.managerInboxesId) === Number(id) &&
      item.treatedBy === null,
  )?.length;
};
export const countManagersInboxes = (usersInboxes: any, id: any) => {
  return usersInboxes.filter(
    (item: any) => Number(item?.managerInboxesId) === Number(id),
  )?.length;
};

export const CountPendingClaimsInboxeByManager = (
  managerNotificationType: any,
  userName: any,
  countInboxes: any,
  inboxeId: any,
) => {
  const groupedCount = groupBy(
    get(countInboxes, 'countPending', [])
      .filter(
        (element: any) =>
          element.readBy?.toUpperCase() === userName?.toUpperCase(),
      )
      .map((el: any) => ({
        ...el,
        managerInboxesId: get(
          managerNotificationType.find(
            (item: any) => item.id === el.managerNotificationTypeId,
          ),
          'managerInboxesId',
        ),
      })),
    'managerInboxesId',
  );
  if (isEmpty(get(groupedCount, `${[inboxeId]}`, []))) {
    return 0;
  } else {
    return sumBy(get(groupedCount, `${[inboxeId]}`, []), 'count');
  }
};

export const countPendingClaimsInboxe = (
  managerNotificationType: any,
  inboxeId: any,
  countInboxes: any,
  isTransactionInboxes: boolean,
) => {
  const groupedCount = groupBy(
    countInboxes.map((el: any) => ({
      ...el,
      managerInboxesId: get(
        managerNotificationType.find(
          (item: any) =>
            item.id ===
            (isTransactionInboxes
              ? el.transactionInboxeAreaId
              : el.managerNotificationTypeId),
        ),
        'managerInboxesId',
      ),
    })),
    'managerInboxesId',
  );
  if (isEmpty(get(groupedCount, `${[inboxeId]}`, []))) {
    return 0;
  } else {
    return sumBy(get(groupedCount, `${[inboxeId]}`, []), 'count');
  }
};
/* istanbul ignore next */
export const countTimeInboxes = (
  managerNotificationType: any,
  inboxeId: any,
  countInboxes: any,
  isTransactionInboxes: boolean,
) => {
  const groupedCount = groupBy(
    countInboxes.map((el: any) => ({
      ...el,
      managerInboxesId: get(
        managerNotificationType.find(
          (item: any) =>
            item.id ===
            (isTransactionInboxes
              ? el.transaction_inboxe_area_id
              : el.manager_notification_type_id),
        ),
        'managerInboxesId',
      ),
    })),
    'managerInboxesId',
  );
  if (isEmpty(get(groupedCount, `${[inboxeId]}`, []))) {
    return ' ';
  } else {
    return (
      getTimeDifference(
        get(groupedCount, `${[inboxeId]}`, [])
          .map((el: any) => el.min)
          .reduce((acc: any, date: any) => {
            return acc && new Date(acc) < new Date(date) ? acc : date;
          }, '') as any,
      )?.days + 'j'
    );
  }
};
